import { useCalculationsQuery } from "@evr/apis/calculation";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectCalculationsQuery } from "@evr/store/slices/calculation";

export const useGetCalculationssQuery = () => {
  const queryParams = useAppSelector(selectCalculationsQuery);
  return useCalculationsQuery(queryParams);
};
